import PropTypes from 'prop-types';
import { css } from '@emotion/react';
import { useRouter } from 'next/router';

import { colors } from 'styles/theme';

import { NHS_REDIRECTS, UK_REDIRECTS } from '../../../utils/constants';
import Link from '../Link/Link';

const linkCss = highlight => css`
  color: ${colors.textColor};
  margin-right: 42px;
  font-weight: ${highlight && 500};
`;

/**
 * @param {object} props
 */

function NavbarLinks({ currentSlug, links }) {
  const router = useRouter();
  const localeCode = router.query.locale;

  const redirects = localeCode === 'uk' ? UK_REDIRECTS : NHS_REDIRECTS;

  return (
    <>
      {links.map(({ href, label }) => (
        <Link
          css={linkCss(currentSlug === href)}
          href={redirects.find(item => item.key === href)?.value}
          key={`${label}-${href}`}
        >
          {label}
        </Link>
      ))}
    </>
  );
}

NavbarLinks.propTypes = {
  currentSlug: PropTypes.string,
  links: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default NavbarLinks;
